<template>
  <div>
    <nav class="lxm-prev-next nav">
      <div class="lxm-prev-next__container nav-center">
        <!--<a class="lxm-prev-next__half nav-item is-tab is-active">上一条</a>-->
        <a class="lxm-prev-next__half nav-item is-tab"
           :class="{ 'is-disabled': !prevAble }"
           @click="prevClicked">上一条</a>
        <a class="lxm-prev-next__half nav-item is-tab"
           :class="{ 'is-disabled': !nextAble }"
           @click="nextClicked">下一条</a>
      </div>
    </nav>
    <div class="lxm-prev-next-placeholder"></div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-prev-next
    position: fixed
    left: 0
    bottom: 0
    width: 100vw
    line-height: 1
    font-size: size-big
    box-shadow: tabs-box-shadow
    background: brand-secondary
  .lxm-prev-next-placeholder
    height: size-big + spacing * 2
  .lxm-prev-next__container
    width: 100%
  .lxm-prev-next__half
    width: 50%
    justify-content: center
    &.nav-item
      padding-top: spacing
      padding-bottom: spacing - siz(5)
      color: grey-darker
      &.is-disabled
        color: grey
      &.is-tab
        border-top-width: 0
        border-bottom-width: siz(5)
        &:hover
          color: brand-primary
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    computed: {
      prevAble () {
        return this.$store.state.pagination.prevTo
      },
      nextAble () {
        return this.$store.state.pagination.nextTo
      }
    },
    methods: {
      prevClicked (e) {
        // this.$emit('prev')
        this.$store.commit(mTypes.TRANSITION_SET_BACK, true)
        this.$router.replace(this.$store.state.pagination.prevTo)
      },
      nextClicked (e) {
        // this.$emit('next')
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.replace(this.$store.state.pagination.nextTo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmPrevNext.vue?0474bb42